import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CompanyForm, CompanyFormData } from "./CompanyForm";
import { useCreateCompany } from "@/hooks/companies/useCompanies";

interface CompanyCreateModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CompanyCreateModal = ({ open, onOpenChange }: CompanyCreateModalProps) => {
  const createCompanyMutation = useCreateCompany();

  const handleSubmit = async (formData: CompanyFormData) => {
    try {
      await createCompanyMutation.mutateAsync(formData);
      onOpenChange(false);
    } catch (error) {
      // Error is handled by the mutation
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Nova Empresa</DialogTitle>
        </DialogHeader>
        
        <CompanyForm
          onSubmit={handleSubmit}
          onCancel={() => onOpenChange(false)}
          isLoading={createCompanyMutation.isPending}
        />
      </DialogContent>
    </Dialog>
  );
};